import BillingHistoryTable from './_components/billing-history-table'

function BillingHistoryPage() {
  return (
    <div className="w-full">
      <div className="flex flex-row justify-between w-full">
        <h1 className="text-2xl md:text-[32px] font-bold mb-2">
          Billing History
        </h1>
      </div>
      <BillingHistoryTable />
    </div>
  )
}

export default BillingHistoryPage
